<div>
    <iframe [src]="iFrameSrc" style="width: 1200px; height: 800px;"></iframe>
</div>
<div class="actions flex justify-end gap-1 p-3 items-center">
    <button kendoButton (click)="onClose(DIALOG_EXIT_CODE.REJECT)" fillMode="clear">Отказ</button>
    <button
      ico
      kendoButton
      [disabled]="isLoading || isCompleteDisabled"
      [primary]="true"
      (click)="onComplete()"
    >
      <kendo-loader *ngIf="isLoading" size="small"></kendo-loader>
      {{ completeLabel }}
    </button>
  </div>